<h1 mat-dialog-title>{{title}}</h1>
<div mat-dialog-content>
    <p>{{sms}}</p>
</div>
<div mat-dialog-actions>
    <button mat-button [mat-dialog-close]="false">Cancelar</button>
    <button mat-button [mat-dialog-close]="true">Aceptar</button>
</div>